import { ThemeTypes } from '../types/theme/themeTypes';

//local storage
export const sidKey = 'SID';
export const IdSystemUser = localStorage.getItem(sidKey);

export const IdHotelOwnerKey = 'IdHotelOwner';
export var IdHotelOwner = localStorage.getItem(IdHotelOwnerKey);

export const usernameKey = 'Username';
export const username = localStorage.getItem(usernameKey);

export const HotelInfoKey = 'hotelInfo';

export const cacheKey = 'cache';

export const defaultLanguage = 'en';
export const customLanguages = ['es', 'fr', 'de'];
export const appLanguages = [defaultLanguage, ...customLanguages];
export const lsLanguageKey = 'language';
export const lsLanguage = localStorage.getItem(lsLanguageKey);
export const defaultTimezone = 'Europe/Madrid';

///// functions
export const getInitialLang = () => {
    const navigatorLanguage = navigator.language || navigator.userLanguage;
    const langCode = (lsLanguage || navigatorLanguage).slice(0, 2);
    if (customLanguages.includes(langCode)) return langCode;
    return defaultLanguage;
};

export const PreferedTheme = 'PreferedTheme';
export const PreferedThemeLS = localStorage.getItem(PreferedTheme);

export const availableThemes = [
    ThemeTypes.LIGHT,
    ThemeTypes.DARK,
    ThemeTypes.SYSTEM,
];

export const getSystemTheme = () => {
    const isDarkMode = window.matchMedia(
        '(prefers-color-scheme: dark)'
    ).matches;
    return isDarkMode ? ThemeTypes.DARK : ThemeTypes.LIGHT;
};

export const getInitialTheme = () => {
    if (PreferedThemeLS && availableThemes.includes(PreferedThemeLS))
        return PreferedThemeLS;

    setLSTheme(ThemeTypes.DARK);
    return ThemeTypes.DARK;
};

export const setLSTheme = theme => {
    localStorage.setItem(PreferedTheme, theme);
};

export const userProfileKeys = ['language', 'timeZone', 'theme'];

export const getUserPermissions = (targetUserName, users) => {
    const targetUser = users.find(
        allowedUser => allowedUser?.SystemUser?.UserName === targetUserName
    );
    return {
        readOnlyUser: targetUser?.ReadOnly || false,
        adminUser: targetUser?.Admin || false,
        MainUser: targetUser?.MainUser || false,
    };
};
